module.exports = __webpack_public_path__ + "img/mouse3.51b18efe.svg";